import { Controller } from "stimulus"

export default class extends Controller {

  static targets = [ "residueType", "collectionUnits", "samplingItems" ]

  connect() {
    if (document.body.getAttribute("data-action").includes("new") || document.body.getAttribute("data-action").includes("create") || document.body.getAttribute("data-action").includes("edit") || document.body.getAttribute("data-action").includes("update")) {
      var cleave = new Cleave(".input-date", {
        date: true,
        datePattern: ["d", "m", "Y"]
      })
    }
  }
}
